/* eslint-disable */
import $ from 'jquery';
/* eslint-enable */

export default function () {
  $('article[data-highlight]').each(function () {
    const text = $(this).data('highlight');
    $(this).highlight(text, { element: 'mark', className: 'highlight' });
  });

  let utils = (function () {
    return {
      escapeRegExChars: function (value) {
        return value.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
      },
      createNode: function (containerClass) {
        let div = document.createElement('div');
        div.className = containerClass;
        div.style.position = 'absolute';
        div.style.display = 'none';
        return div;
      }
    };
  }());

  let searchInput = $('#SearchForm_SearchForm_Search');
  let searchForm = $('#SearchForm_SearchForm');
  let searchFormHolder = $('#SearchForm_SearchForm_Search_Holder');

  $(document).ready(function () {

    $(searchInput).focus(function () {
      $(this).attr("rel", $(this).attr("placeholder"));
      $(this).removeAttr("placeholder");
    });
    $(searchInput).blur(function () {
      $(this).attr("placeholder", $(this).attr("rel"));
      $(this).removeAttr("rel");
    });

    $(searchInput).on("click", function () {
      if ($(searchInput).is(":focus")) {
        $(searchInput).attr('autocomplete', 'off');


        /* $(searchFormHolder).animate(
             {width: '99%'},
             500, function () {*/



        searchInput.autocomplete({
          serviceUrl: 'json/fullsearch',
          showNoSuggestionNotice: true,
          autoSelectFirst: true,
          groupBy: 'category',
          onSelect: function (suggestion) {
            let url = suggestion.data.urlLink;
            window.location.replace(url);
          },
          formatResult: function (suggestion, currentValue) {

            // Do not replace anything if the current value is empty
            if (!currentValue) {
              return suggestion.value;
            }

            let pattern = '(' + utils.escapeRegExChars(currentValue) + ')';

            let getSuggestion = function (value) {
              return value
                  .replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>')
                  .replace(/&/g, '&amp;')
                  .replace(/</g, '&lt;')
                  .replace(/>/g, '&gt;')
                  .replace(/"/g, '&quot;')
                  .replace(/&lt;(\/?strong)&gt;/g, '<$1>');
            };

            return '<div class="row border-bottom align-items-center">' +
                //'<div class="col col-md-2 show-list-col show-list-image-col h-100">' +
                //'<img class="img-responsive" src="' + suggestion.icon + '" >' +
                //'</div>' +
                '<div class="col col-md-12 show-list-col show-list-info-col h-100">' +
                '<div class="row show-list-info-row">' +
                '<div class="col-12"><p class="pt-2 mb-1 pb-0">' + getSuggestion(suggestion.name) + '</p></div>' +
                '</div>' +
                '</div>' +
                '</div>';
          }
        });





        //  });
      }
    });

    /* $(searchInput).focusout(function () {
         $(searchFormHolder).animate({width: '30%'});
     });*/

    let searchSubmit = function () {
      searchForm.submit();
      //searchForm.submit(function (event) {
       // let noSuggestion = $('.autocomplete-no-suggestion');
        //console.log('checking..');
        /*if (noSuggestion.length) {
          //console.log('no results..');
          event.preventDefault();
        }*/
      //});
    };

    //searchSubmit();

    $("#inputGroupAppend").click(function () {
      searchSubmit();
    });

  });

}
